import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'
import theme from '@shared/utils/theme'
import PageHeader from './PageHeader'
import Actions from '../components/Actions'
import { Comment } from '@shared/components/Text'

const PageLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  color: ${ theme.palette.black };
  > .content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin: 0 20px;
  }
  > .actions {
    margin-top: 20px;
  }
`

function PageLayout({ title, comment, onPrevious, prevLink, actions, children, ...props }) {

  useLayoutEffect(() => {
    window.scrollTo({
      top: 0
    })
  }, [])
  return (
    <PageLayoutContainer { ...props }>
      <PageHeader
        onPrevious={ onPrevious }
        prevLink={ prevLink }
      >
        <div>{ title }
          { comment && <Comment>
            <div>{ comment }</div>
          </Comment> }
        </div>
      </PageHeader>
      <div className="content">
        { children }
      </div>
      {
        actions && <Actions
          { ...actions }
        />
      }
    </PageLayoutContainer>
  )
}

export default PageLayout
